export default "__VITE_ASSET__r81zPaLs__"